import React, { useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import * as actionCreators from "../modules/actions";

const Impersonate = (props) => {
	useEffect(() => {
		const params = new URLSearchParams(props.location.search);
		const token = params.get("token");

		if (!token) {
			props.history.push("/login");
			return;
		}

		window.history.replaceState({}, "", "/impersonate");

		sessionStorage.setItem("userToken", JSON.stringify(token));
		sessionStorage.setItem("isImpersonated", "true");
		axios.defaults.headers.common["Authorization"] = "Bearer " + token;
		props.handleClientLoaded();
		props.history.push("/dashboard");
	}, []);

	return null;
};

const mapDispatchToProps = (dispatch) => ({
	handleClientLoaded: () => dispatch(actionCreators.handleClientLoaded()),
});

export default connect(null, mapDispatchToProps)(Impersonate);
